import { Measure } from "@/store/models/Measure";

const state = {    
    measures:[]
}

const getters = {
        
}

const actions = {
    async init({commit, dispatch, rootState}){
        const measures = localStorage.getItem('measures')? JSON.parse(localStorage.getItem('measures')) : (rootState.metadata.models.views.telemetry ? (rootState.metadata.models.views.telemetry.default_measures || []) : []);
        if(measures.length){
            commit('updateMeasures', measures.map( m => Measure.deserialize(m)));
        }
    },

    fetchMeasures({commit, dispatch}){
        return new Promise(
            (resolve, reject)=>{
                try {
                    const measures = JSON.parse(localStorage.getItem('measures') || []);
                    commit('updateMeasures', measures.map( m => Measure.deserialize(m)));
                    resolve(measures);
                } catch (error) {
                    reject(error)
                }
            }
        )  
    },

    addMeasure({commit, dispatch, rootState}, measures){
        return new Promise(
            (resolve)=>{
                try {
                    const newMeasures = rootState.map.labels.concat(measure);
                    localStorage.setItem('measures', JSON.stringify(newLabels));
                    commit('updateMeasures', newMeasures);
                    resolve()
                } catch (error) {
                    reject(error);   
                }
            }
        )  
    },

    removeMeasure({commit, dispatch}, measures){
        return new Promise(
            (resolve, reject)=>{
                try {
                    const newMeasures = state.labels.filter(l => m.id != label.id)
                    localStorage.setItem('measures', JSON.stringify(newMeasures));
                    commit('updateMeasures', newMeasures);
                    resolve()
                } catch (error) {
                    reject(error);
                }
            }
        )    
    },

}

const mutations = {
    updateMeasures(state, measures){
        state.measures = measures
    },

}

export default{
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
    namespaced:true
}